import axiosInstance from "./baseUrl";

export const fetchRequestsSummary = async () => {
  const response = await axiosInstance.get(
    `/v1/buyer-requests/admin/dashboard`
  );
  return response.data;
};
export const fetchBuyersRequests = async (params: any) => {
  const response = await axiosInstance.get(
    `/v1/buyer-requests/admin/requests`,
    { params }
  );
  return response.data;
};
export const fetchAllActiveBags = async (params: any) => {
  const response = await axiosInstance.get(
    `/v1/bag/admin/get-all-bags`,
    { params }
  );
  return response.data;
};

export const fetchPaidBags = async (params: any) => {
  const response = await axiosInstance.get(
    `/v1/bag/admin/get-all-bags-with-paid-orders`,
    { params }
  );
  return response.data;
};
export const fetchBuyerRequestDetails = async (requestId: any) => {
  const response = await axiosInstance.get(
    `/v1/buyer-requests/admin/requests/${requestId}`
  );
  return response.data;
};
export const fetchVendorsResponses = async (params: any) => {
  const response = await axiosInstance.get(
    `/v1/buyer-requests/admin/vendor-responses`,
    { params }
  );
  return response.data;
};
